import { Chip, Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    chips: {
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
    },
}));

export function TagsContainer({ contact, ticketId }) {
    const classes = useStyles();
    const [tags, setTags] = useState([]);
    const [selecteds, setSelecteds] = useState([]);
    const isMounted = useRef(true);

    useEffect(() => {
        return () => { isMounted.current = false; };
    }, []);

    useEffect(() => {
        if (!isMounted.current) return;
        loadTags().then(() => {
            if (contact && Array.isArray(contact.tags)) {
                setSelecteds(contact.tags.filter(t => t.kanban !== 1).map(t => t.id));
            } else {
                setSelecteds([]);
            }
        });
    }, [contact]);

    const loadTags = async () => {
        try {
            const { data } = await api.get(`/tags/list`, { params: { kanban: 0 } });
            if (isMounted.current) setTags(data);
        } catch (err) {
            toastError(err);
        }
    };

    const syncTags = async (selectedIds) => {
        try {
            const selectedTags = tags.filter(t => selectedIds.includes(t.id));
            const url = ticketId ? `/tags/sync/${ticketId}` : `/tags/sync`;
            await api.post(url, { contactId: contact?.id, tags: selectedTags });
        } catch (err) {
            toastError(err);
        }
    };

    const onChange = async (e) => {
        const value = e.target.value;
        setSelecteds(value);
        await syncTags(value);
    };

    const renderSelected = (selectedIds) => {
        if (!selectedIds.length) return null;
        return (
            <div className={classes.chips}>
                {selectedIds.map(id => {
                    const tag = tags.find(t => t.id === id);
                    if (!tag) return null;
                    return (
                        <Chip
                            key={id}
                            size="small"
                            label={tag.name}
                            style={{
                                backgroundColor: tag.color || "#eee",
                                color: "#fff",
                                fontWeight: "bold",
                                borderRadius: 3,
                                fontSize: "0.8em",
                            }}
                        />
                    );
                })}
            </div>
        );
    };

    return (
        <FormControl fullWidth margin="dense" variant="outlined">
            <InputLabel id="contact-tags-label">Tags</InputLabel>
            <Select
                multiple
                labelId="contact-tags-label"
                label="Tags"
                labelWidth={40}
                value={selecteds}
                onChange={onChange}
                renderValue={renderSelected}
                MenuProps={{
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    transformOrigin: { vertical: "top", horizontal: "left" },
                    getContentAnchorEl: null,
                }}
            >
                {tags.map(tag => (
                    <MenuItem key={tag.id} value={tag.id}>
                        <Chip
                            size="small"
                            label={tag.name}
                            style={{
                                backgroundColor: tag.color || "#eee",
                                color: "#fff",
                                fontWeight: "bold",
                                borderRadius: 3,
                                fontSize: "0.8em",
                                marginRight: 6,
                                pointerEvents: "none",
                            }}
                        />
                        {tag.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
